import ReducerCreator from '../registerReducer';
import { buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as DIGITALSETS from './digitalSets.constants';
import { DigitalSet } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<DigitalSet>()
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_LOAD, (state, payload) => {
        const res = copyStoreItem(state.dictionary);
        res.isLoading = true;
        res.isLoaded = false;
        return res;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_UPDATE, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: true });
        return result;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_UPDATE_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        payload.forEach(p => result.dictionary[p.guid] = p);
        result.isLoading = false;
        result.isLoaded = true;
        return result;
    })
    .register<any>(DIGITALSETS.DIGITAL_SETS_UPDATE_ERROR, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: true, errorMessage: payload.reason });
        return result;
    })
    .register<void>(DIGITALSETS.DIGITAL_SETS_DELETE, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: true });
        return result;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_DELETE_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        payload.forEach(p => delete (result.dictionary[p.guid]));
        result.isLoaded = true;
        result.isLoading = false;
        return result;
    })
    .register<DigitalSet>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<DigitalSet>();
    })
    ;

export function digitalSetsReducer(state: StoreItem<DigitalSet> = new StoreItem<DigitalSet>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}